import React, { Component } from 'react';

class BoolInput extends Component {


  componentDidMount() {
  }

  render() {
    if(this.props.edit){
      return <input type="checkbox" checked={this.props.value} onChange={(e) => this.props.changeValue(this.props.name, !this.props.value)} />;
    }else{
      if(this.props.circle){
        return <div className={`circle circle--small ${this.props.value ? "circle--green" : "circle--red"}`} />
      }else{
        return <div>{this.props.value ? "true" : "false"}</div>;
      }
    }
  }

}

export default BoolInput;



// WEBPACK FOOTER //
// ./src/elements/BoolInput.js